import Vue from 'vue';
import Buefy from 'buefy';
import moment from 'moment';
import { decode } from 'html-entities';
import { ModalProgrammatic as Modal } from 'buefy';
import VueNumber from 'vue-number-animation';
import VueUploadComponent from 'vue-upload-component'
import "core-js/stable";
import "regenerator-runtime/runtime";
import axios from 'axios';

import _ from 'lodash';

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ScrollTo from 'vue-scrollto';

import CaseLawMixin from './mixins/CaseLawFormMixin';

import CRUDMixin from './mixins/CRUDMixin';
import LocalStorageMixin from './mixins/LocalStorageMixin';
moment.locale('en-gb');
window.Vue = require('vue');
window.htmlEntity = require('html-entities');
window.moment = require('moment');
window.Modal = Modal;
window.axios = axios;
window._ = _;



import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import HighchartsSankey from 'highcharts/modules/sankey';
import HighchartsDrillDown from 'highcharts/modules/drilldown';
import HighchartsWordCloud from 'highcharts/modules/wordcloud';
import HighchartsNetworkGraph from 'highcharts/modules/networkgraph';
import HighchartsMore from 'highcharts/highcharts-more';
import treemap from 'highcharts/modules/treemap';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';

import VueSlider from 'vue-slider-component';
import VueRecaptcha from 'vue-recaptcha';
import TextHighlight from 'vue-text-highlight';

import VueClipboard from 'vue-clipboard2';

Vue.prototype.$services = {
    'additionalDecidingBodies': require("./services/AdditionalDecidingBodiesService").default,

    'articles': require("./services/ArticlesService").default,
    'articleItems': require("./services/ArticleItemsService").default,
    'caseLawDigestAttachments': require("./services/CaseLawDigestAttachmentsService").default,
    'caseLaws': require("./services/CaseLawsService").default,
    'caseLawChanges': require("./services/CaseLawChangesService").default,

    'caseLawStatuses': require("./services/CaseLawStatusesService").default,
    'caseLawSuggestions': require("./services/CaseLawSuggestionsService").default,
    'countries': require("./services/CountriesService").default,
    'decidingBodies': require("./services/DecidingBodiesService").default,
    'dialects': require("./services/DialectsService").default,
    'emailTemplates': require("./services/EmailTemplatesService").default,
    'instances': require("./services/InstancesService").default,
    'ipCategories': require("./services/IPCategoriesService").default,
    'legalProcedures': require("./services/LegalProceduresService").default,
    'questionAndFeedbacks': require("./services/QuestionAndFeedbacksService").default,
    'registration': require("./services/RegistrationService").default,
    'staticContents': require("./services/StaticContentsService").default,
    'users': require("./services/UsersService").default
};



window.caseLawMixin = CaseLawMixin;
window.crudMixin = CRUDMixin;

HighchartsSankey(Highcharts);
HighchartsDrillDown(Highcharts);
HighchartsWordCloud(Highcharts);
HighchartsNetworkGraph(Highcharts);
HighchartsMore(Highcharts);

treemap(Highcharts);
exporting(Highcharts);
exportData(Highcharts);

Vue.use(HighchartsVue);
Vue.use(CKEditor);
Vue.use(ScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

Vue.mixin(LocalStorageMixin);

Vue.use(VueClipboard);

Vue.component('file-upload', VueUploadComponent);
Vue.component('vue-slider', VueSlider);
Vue.component('vue-recaptcha', VueRecaptcha);

Vue.component('text-highlight', TextHighlight);

Highcharts.theme = {
    colors: ['#24c280', '#24c28080', '#0092cd', '#0092cd80', '#d9643c', '#d9643c80', '#e1dd5f', '#e1dd5f80'],
};
Highcharts.setOptions(Highcharts.theme);

Vue.use(VueNumber);
Vue.use(Buefy,
    {
        defaultProgrammaticPromise: true,
        defaultIconPack: 'fas',
        defaultContainerElement: '#app',
        defaultLocale: 'en_GB'
        // ... https://buefy.org/documentation/constructor-options
    });

Vue.filter('dateFilter', function (value) {
    if (value) {
        
        return moment(String(value)).format('DD/MM/YYYY');
    }
});

Vue.filter('dateTimeFilter', function (value) {
    if (value) {
        return moment(Strinqqqqg(value)).format('DD/MM/YYYY hh:mm:ss a');
    }
});

Vue.filter('chatDateTimeFilter', function (value) {
    if (value) {
        return moment(String(value)).format('DD MMM YYYY HH:mm');
    }
});

Vue.filter('dateMonthNameFilter', function (value) {
    if (value) {
        return moment(String(value)).format('DD MMMM YYYY');
    }
});

Vue.filter('stripHtml', function (value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text;
});

Vue.filter('decodeHTMLEntity', function (value) {
    if (value) {
        return decode(value);
    }
});
Vue.filter('stripParagraphTags', function (value) {
    if (value) {
        return value.replace(/(<p[^>]+?>|<p>|<\/p>)/img, "");;
   
    }
});
Vue.filter('highlightText', function (str, queries) {


    const query = queries[0];
     
    const check = new RegExp(query, 'gi');
    
    if (str && query) {
        console.log(str);
        console.log(query);
        
        return str.toString().replace(check, function (matchedText, a, b) {
            return (`<mark index="0" text="${matchedText}" class="text__highlight text__highlight has-text-weight-bold has-background-white is-italic">${matchedText}</mark>`);
        });
    }
   
    return str;
});
Vue.filter('parsedHtml', function (str) {

    const parser = new DOMParser();
    const elem = parser.parseFromString(str, 'text/html');

    return elem.body.innerText;
});
Vue.directive('formatdate', {
    mounted(el) {
        console.log(moment(String(el.value)).format('DD/MM/YYYY'))
        el.value = moment(String(el.value)).format('DD/MM/YYYY');

    },
    update(el) {
        console.log(el)

        el.value = moment(String(el.value)).format('DD/MM/YYYY');
    }
})
let handleOutsideClick;
Vue.directive('closable', {
    bind(el, binding, vnode) {
        // Here's the click/touchstart handler
        // (it is registered below)
        handleOutsideClick = (e) => {
            e.stopPropagation();
            // Get the handler method name and the exclude array
            // from the object used in v-closable
            const { handler, exclude } = binding.value;
            // This variable indicates if the clicked element is excluded
            let clickedOnExcludedEl = false;
            exclude.forEach(refName => {
                // We only run this code if we haven't detected
                // any excluded element yet
                if (!clickedOnExcludedEl) {
                    // Get the element using the reference name
                    const excludedEl = vnode.context.$refs[refName];
                    // See if this excluded element
                    // is the same element the user just clicked on
                    if (excludedEl) clickedOnExcludedEl = excludedEl.contains(e.target);
                }
            })
            // We check to see if the clicked element is not
            // the dialog element and not excluded
            if (!el.contains(e.target) && !clickedOnExcludedEl) {
                // If the clicked element is outside the dialog
                // and not the button, then call the outside-click handler
                // from the same component this directive is used in
                vnode.context[handler]();
            }
        }
        // Register click/touchstart event listeners on the whole page
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);
    },
    unbind() {
        // If the element that has v-closable is removed, then
        // unbind click/touchstart listeners from the whole page
        document.removeEventListener('click', handleOutsideClick);
        document.removeEventListener('touchstart', handleOutsideClick);
    }
});

require('./components/component-loader');

